import axios from "axios";
import {  GetAllNotifiche2023FiltersDTO, GetAllNotifiche2023ResponseData } from "./dto";
import { MonitoringNotifiche2023Service } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class MonitoringNotifiche2023Impl implements MonitoringNotifiche2023Service {

    public GetAllNotifiche2023(filters: GetAllNotifiche2023FiltersDTO): Promise<GetAllNotifiche2023ResponseData[]> {
        return axios.get("/api/monitoring/starting-phase", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                headQuarters: filters.headQuarters ? filters.headQuarters : '',
                notType: filters.notType ? filters.notType : '',
                notSuperata: filters.notSuperata ? filters.notSuperata : ''
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}